import { render } from "./ResearchIntegrity.vue?vue&type=template&id=1f47335e"
import script from "./ResearchIntegrity.vue?vue&type=script&lang=js"
export * from "./ResearchIntegrity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__